var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "tab-pane fade in active", attrs: { id: "tab_tracking" } },
    [
      _c("div", { staticClass: "tab__header" }, [_vm._v("Tracking Sheet")]),
      _vm._v(" "),
      _c("Comparisons"),
      _vm._v(" "),
      _c("div", { staticClass: "tab__sub-header" }, [
        _vm._v("High-Level Performance Tracking")
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "kpi__table-container" }, [
        _c(
          "table",
          { staticClass: "kpi-table" },
          [
            _c(
              "tr",
              { staticClass: "kpi-table__header" },
              [
                _c("th", { attrs: { colspan: "2" } }, [
                  _vm._v("High-Level Performance Tracking")
                ]),
                _vm._v(" "),
                _c("th", { staticClass: "target" }, [_vm._v("Monthly")]),
                _vm._v(" "),
                _vm._l(_vm.monthAbbreviations, function(months) {
                  return _c("th", [_vm._v(_vm._s(months))])
                }),
                _vm._v(" "),
                _c("th", { attrs: { colspan: "3" } }, [_vm._v("YTD")])
              ],
              2
            ),
            _vm._v(" "),
            _c(
              "tr",
              { staticClass: "kpi-table__header" },
              [
                _c("th", { attrs: { colspan: "2" } }, [_vm._v("Description")]),
                _vm._v(" "),
                _c("th", { staticClass: "target" }, [_vm._v("Target")]),
                _vm._v(" "),
                _vm._l(_vm.monthAbbreviations, function(months) {
                  return _c("th", [_vm._v("Actual")])
                }),
                _vm._v(" "),
                _c("th", [_vm._v("Target")]),
                _vm._v(" "),
                _c("th", [_vm._v("Actual")]),
                _vm._v(" "),
                _c("th", [_vm._v("Variance")])
              ],
              2
            ),
            _vm._v(" "),
            _vm._l(_vm.metricsHighLevelPerformance, function(metric, index) {
              return _c(_vm.getComponentName(metric.field), {
                key: "row-high-level-" + index,
                tag: "component",
                attrs: { index: index, metric: metric }
              })
            })
          ],
          2
        )
      ]),
      _vm._v(" "),
      _vm._m(0),
      _vm._v(" "),
      _c("div", { staticClass: "tab__sub-header" }, [
        _vm._v("Key Performance Indicators")
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "kpi__table-container" }, [
        _c(
          "table",
          { staticClass: "kpi-table" },
          [
            _c(
              "tr",
              { staticClass: "kpi-table__header" },
              [
                _c("th", { attrs: { colspan: "2" } }, [
                  _vm._v("Key Performance Indicators")
                ]),
                _vm._v(" "),
                _c("th", { staticClass: "target" }, [_vm._v("Monthly")]),
                _vm._v(" "),
                _vm._l(_vm.monthAbbreviations, function(months) {
                  return _c("th", [_vm._v(_vm._s(months))])
                }),
                _vm._v(" "),
                _c("th", { attrs: { colspan: "3" } }, [_vm._v("YTD")])
              ],
              2
            ),
            _vm._v(" "),
            _c(
              "tr",
              { staticClass: "kpi-table__header" },
              [
                _c("th", { attrs: { colspan: "2" } }, [_vm._v("Description")]),
                _vm._v(" "),
                _c("th", { staticClass: "target" }, [_vm._v("Target")]),
                _vm._v(" "),
                _vm._l(_vm.monthAbbreviations, function(months) {
                  return _c("th", [_vm._v("Actual")])
                }),
                _vm._v(" "),
                _c("th", [_vm._v("Target")]),
                _vm._v(" "),
                _c("th", [_vm._v("Actual")]),
                _vm._v(" "),
                _c("th", [_vm._v("Variance")])
              ],
              2
            ),
            _vm._v(" "),
            _vm._l(_vm.metricsKeyIndicatorsPerformance, function(
              metric,
              index
            ) {
              return _c(_vm.getComponentName(metric.field), {
                key: "row-key-indicators-" + index,
                tag: "component",
                attrs: { index: index, metric: metric }
              })
            })
          ],
          2
        )
      ])
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "legend" }, [
      _c("span", {
        staticClass: "legend__key kpi-performance-table__month--selected"
      }),
      _vm._v(" = Selected Month")
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }